module.exports = __webpack_public_path__ + "static/media/OutliersQ4_2.2130c425.svg";